import { get } from "lodash";
import { getPagePath } from "./collection";

export function getMagazinePagePath(magazine, config) {
  const magazineObject = get(config, ["magazines"], []).find(m => m.id === magazine.id);
  return `${magazineObject.url}`;
}

export function addPagePathtoMagazineIssues(magazine, config) {
  console.log("config", config);
  const collection = get(magazine, ["collections"], []);
  collection.forEach(c => (c["pagePath"] = getPagePath(c, config)));
  return magazine;
}
